import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getApplicationData } from 'selectors/getApplicationData';
import { getCreditScoreHistoryState } from 'selectors/getCreditScoreHistory';
import { getCreditScoreHistory } from 'thunks';
import CreditScoreGauge from 'components/CreditScoreGauge';
import { CreditScoreSource } from 'api/ReportsApi';

import styles from './CreditScoreSection.module.scss';

const CreditScoreSection: React.FC = () => {
  const { application } = useSelector(getApplicationData);
  const history = useSelector(getCreditScoreHistoryState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (application?.id) {
      dispatch(getCreditScoreHistory(application.id));
    }
  }, [application?.id, dispatch]);

  if (!application || !history || history.length === 0) return null;

  const efxHistory = history.filter((entry) => entry.source === CreditScoreSource.Equifax);

  const sortedHistory = [...efxHistory].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  if (sortedHistory.length === 0) return null;
  const latestScore = sortedHistory[0].score;
  const previousScore = sortedHistory[1]?.score;
  const change = previousScore ? latestScore - previousScore : 0;

  return (
    <div className={styles.section}>
      <p className={styles.sectionLabel}>
        Credit Score<span className={styles.sectionLabelAsterisk}>*</span>
      </p>
      <CreditScoreGauge score={latestScore} change={change} />
    </div>
  );
};

export default CreditScoreSection;
